import React, {
  useState,
  useEffect,
} from "react";
import toastr from "toastr";
import { useTranslation } from "react-i18next";
import { postData } from "../../services/api";
import Button from "../form/Button";
import { classNames } from "../../helper/classNames";
import Input from "../form/Input";
import Select from "../form/Select";
import Textarea from "../form/Textarea";
import OtherStudyPopup from "./OtherStudyPopup";
import OtherIndustryPopup from "./OtherIndustryPopup";

const AddEditPerspectiveBoardmember = ({
  isOpen,
  setIsOpen = () => {},
  loadList = () => {},
  data,
}) => {
  const { t } = useTranslation();
  const [education, setEducation] = useState([]);
  const [studies, setStudies] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [enabledOtherStudyPopup, setEnabledOtherStudyPopup] = useState(false);
  const [enabledOtherIndustryPopup, setEnabledOtherIndustryPopup] =
    useState(false);
  const [otherIndustryType, setOtherIndustryType] = useState("");
  const [actionValue, setActionValue] = useState({});
  const [isSave, setIsSave] = useState(false);
  const [lastname, setLastname] = useState("");
  const [firstname, setFirstname] = useState("");
  const [edu, setEdu] = useState("");
  const [study, setStudy] = useState("");
  const [industry, setIndustry] = useState("");
  const [industry1, setIndustry1] = useState("");
  const [industry2, setIndustry2] = useState("");
  const [boardMambersDetails, setBoardMambersDetails] = useState({});
  const [detailsId, setDetailsId] = useState("");
  const [message, setMessage] = useState("");

  const closePopup = () => {
    setIsOpen({
      open: false,
      data: null,
    });
    setFirstname();
    setLastname();
    setEdu();
    setStudy();
    setIndustry();
    setIndustry1();
    setIndustry2();
    setMessage();
    setBoardMambersDetails({});
  };

  useEffect(() => {
    const loadBoardMemberDetails = async () => {
      try {
        const result = await postData("perspective-board-member/details", {
          id: data?._id,
        });
        if (result.data) {
          setBoardMambersDetails(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadBoardMemberDetails();
  }, [data?._id]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "study_add") {
      setStudies([...studies, actionValue?.result]);
      setStudy(actionValue.row_id);
    } else if (actionValue && actionValue.button_type === "industry_add") {
      setIndustries([...industries, actionValue?.result]);
      setIndustry(actionValue.row_id);
    } else if (actionValue && actionValue.button_type === "industry_add1") {
      setIndustries([...industries, actionValue?.result]);
      setIndustry1(actionValue.row_id);
    } else if (actionValue && actionValue.button_type === "industry_add2") {
      setIndustries([...industries, actionValue?.result]);
      setIndustry2(actionValue.row_id);
    }
  }, [actionValue,studies,industries]);

  const onSubmit = async (e) => {
    setIsSave(true);
    try {
      let path;
      let payload;
      if (data?._id) {
        path = "perspective-board-member/update";
        payload = {
          id: detailsId,
          first_name: firstname,
          last_name: lastname,
          education: edu,
          study: study !== "others" ? study : null,
          industry: industry !== "others" ? industry : null,
          industry1: industry1 !== "others" ? industry1 : null,
          industry2: industry2 !== "others" ? industry2 : null,
          comments: message,
        };
      } else {
        path = "perspective-board-member/create";
        payload = {
          first_name: firstname,
          last_name: lastname,
          education: edu,
          study: study !== "others" ? study : null,
          industry: industry !== "others" ? industry : null,
          industry1: industry1 !== "others" ? industry1 : null,
          industry2: industry2 !== "others" ? industry2 : null,
          comments: message,
        };
      }
      const result = await postData(path, payload);
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setIsSave(false);
        closePopup();
        loadList();
      } else {
        toastr.error(result.message);
        setIsSave(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsSave(false);
    }
  };

  useEffect(() => {
    if (data?._id && Object.keys(boardMambersDetails).length > 0) {
      setDetailsId(boardMambersDetails?._id);
      setLastname(boardMambersDetails?.last_name);
      setFirstname(boardMambersDetails?.first_name);
      setEdu(boardMambersDetails?.education);
      setStudy(boardMambersDetails?.study);
      setIndustry(boardMambersDetails?.industry);
      setIndustry1(boardMambersDetails?.industry_one);
      setIndustry2(boardMambersDetails?.industry_two);
      setMessage(boardMambersDetails?.comments);
    }else{
      setDetailsId('');
      setLastname('');
      setFirstname('');
      setEdu('');
      setStudy('');
      setIndustry('');
      setIndustry1('');
      setIndustry2('');
      setMessage('');
    }
  }, [boardMambersDetails, data]);

  useEffect(() => {
    async function educationList() {
      try {
        const result = await postData("education/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          isBoardMember: 1,
        });
        if (result.data) {
          setEducation(result.data);
        } else {
          console.log("Education message", result.message);
        }
      } catch (error) {
        console.log("Error education catch", error.message);
      }
    }
    educationList();

    async function studyList() {
      try {
        const result = await postData("filter-item/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          type: "study",
        });
        if (result.data) {
          setStudies(result.data);
        } else {
          console.log("Education message", result.message);
        }
      } catch (error) {
        console.log("Error education catch", error.message);
      }
    }
    studyList();

    async function industryList() {
      try {
        const result = await postData("industry/list", {
          sortQuery: { created_at: 1 },
          status: 1,
        });
        if (result.data) {
          setIndustries(result.data);
        } else {
          console.log("Industry message", result.message);
        }
      } catch (error) {
        console.log("Error education catch", error.message);
      }
    }
    industryList();
  }, []);

  return (
    <div className="relative z-50 overflow-hidden w-full">
      <div
        className={classNames(
          "fixed inset-0 bg-black bg-opacity-25 transition-all duration-300",
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        )}
      />
      <div
        className={classNames(
          "fixed inset-0 overflow-y-auto transition-all duration-300",
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        )}
      >
        <div className="flex h-screen justify-end w-full overflow-hidden">
          <div
            className={classNames(
              "w-full flex flex-col max-w-3xl rounded-l-2xl p-4 bg-white text-left align-middle shadow-xl transition-all duration-300",
              isOpen ? "translate-x-0" : "translate-x-full"
            )}
          >
            <div className="relative flex-shrink-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900 text-center mb-4">
                {data?._id
                  ? "Edit Perspective Boardmember"
                  : "Add Perspective Boardmember"}
              </h3>
              <div className="absolute -top-4 -right-4 z-10">
                <Button
                  buttonLabelClasses=""
                  buttonType={"button"}
                  buttonIcon={"fa-light fa-times"}
                  buttonIconPosition={"left"}
                  buttonLabel={""}
                  buttonClasses={
                    "!bg-transparent !text-slate-700 !w-10 !h-10 !p-0"
                  }
                  functions={() => {
                    closePopup();
                  }}
                />
              </div>
            </div>
            <div className="relative mt-2 flex-shrink flex-grow flex flex-col">
              <div className="relative grid grid-cols-1 gap-4">
                <div className="relative bg-white rounded shadow divide-y divide-slate-200">
                  <div className="py-8 px-6 flex flex-col">
                    <div className="space-y-4 mt-4">
                      <div className="flex items-start gap-4">
                        <div className="relative w-2/4 max-w-[calc(50%-1rem)]">
                          <Input
                            label={t("last_name")}
                            labelClasses={"!text-xs !font-semibold"}
                            inputType={"text"}
                            inputPlaceholder={t("enter_last_name")}
                            inputValue={lastname}
                            setInput={setLastname}
                            requiredDisplay={true}
                          />
                        </div>
                        <div className="relative w-2/4 max-w-[calc(50%-1rem)]">
                          <Input
                            label={t("first_name")}
                            labelClasses={"!text-xs !font-semibold"}
                            inputType={"text"}
                            inputPlaceholder={t("enter_first_name")}
                            inputValue={firstname}
                            setInput={setFirstname}
                            requiredDisplay={true}
                          />
                        </div>
                      </div>
                      <div className="flex items-start gap-4">
                        <div className="relative w-2/4 max-w-[calc(50%-1rem)]">
                          <Select
                            label={t("education")}
                            labelClasses={"!text-xs !font-semibold"}
                            xPlacement={"left"}
                            selectedValue={edu}
                            dropdownClass={"!w-60"}
                            dropdownData={[
                              {
                                _id: " ",
                                label: t("select_education"),
                                value: "",
                              },
                              ...education.map((item) => ({
                                _id: item?._id,
                                label: item?.name,
                                value: item?._id,
                              })),
                            ].filter((itm) => itm)}
                            getSelectedValue={(e) => {
                              setEdu(e._id);
                            }}
                            requiredDisplay={true}
                          />
                        </div>
                        <div className="relative w-2/4 max-w-[calc(50%-1rem)]">
                          <Select
                            label={t("field_of_study")}
                            labelClasses={"!text-xs !font-semibold"}
                            xPlacement={"left"}
                            selectedValue={study}
                            dropdownClass={"!w-60"}
                            dropdownData={[
                              {
                                _id: "",
                                label: t("select_study"),
                                value: "",
                              },
                              ...studies.map((item) => ({
                                _id: item?._id,
                                label: item?.name,
                                value: item?._id,
                              })),
                              {
                                _id: "others",
                                label: t("other"),
                                value: "others",
                              },
                            ].filter((itm) => itm)}
                            getSelectedValue={(e) => {
                              if (e._id === "others") {
                                setEnabledOtherStudyPopup(true);
                              }
                              setStudy(e._id);
                            }}
                            requiredDisplay={true}
                          />
                        </div>
                      </div>
                      <div className="flex items-start gap-4">
                        <div className="relative w-2/4 max-w-[calc(50%-1rem)]">
                          <Select
                            label={t("industry_experience")}
                            labelClasses={"!text-xs !font-semibold"}
                            xPlacement={"left"}
                            selectedValue={industry}
                            dropdownClass={"!w-60"}
                            dropdownData={[
                              {
                                _id: "",
                                label: t("select_industry"),
                                value: "",
                              },
                              ...industries.map((item) => ({
                                _id: item?._id,
                                label: item?.name,
                                value: item?._id,
                              })),
                              {
                                _id: "others",
                                label: t("other"),
                                value: "others",
                              },
                            ].filter((itm) => itm)}
                            getSelectedValue={(e) => {
                              if (e._id === "others") {
                                setEnabledOtherIndustryPopup(true);
                                setOtherIndustryType("industry_add");
                              }
                              setIndustry(e._id);
                            }}
                            requiredDisplay={true}
                          />
                        </div>
                        <div className="relative w-2/4 max-w-[calc(50%-1rem)]">
                          <Select
                            label={t("industry_experience_2")}
                            labelClasses={"!text-xs !font-semibold"}
                            xPlacement={"left"}
                            selectedValue={industry1}
                            dropdownClass={"!w-60"}
                            dropdownData={[
                              {
                                _id: "",
                                label: t("select_industry"),
                                value: "",
                              },
                              ...industries.map((item) => ({
                                _id: item?._id,
                                label: item?.name,
                                value: item?._id,
                              })),
                              {
                                _id: "others",
                                label: t("other"),
                                value: "others",
                              },
                            ].filter((itm) => itm)}
                            getSelectedValue={(e) => {
                              if (e._id === "others") {
                                setEnabledOtherIndustryPopup(true);
                                setOtherIndustryType("industry_add1");
                              }
                              setIndustry1(e._id);
                            }}
                            requiredDisplay={false}
                          />
                        </div>
                      </div>
                      <div className="flex items-start gap-4">
                        <div className="relative w-2/4 max-w-[calc(50%-1rem)]">
                          <Select
                            label={t("industry_experience_3")}
                            labelClasses={"!text-xs !font-semibold"}
                            xPlacement={"left"}
                            selectedValue={industry2}
                            dropdownClass={"!w-60"}
                            dropdownData={[
                              {
                                _id: "",
                                label: t("select_industry"),
                                value: "",
                              },
                              ...industries.map((item) => ({
                                _id: item?._id,
                                label: item?.name,
                                value: item?._id,
                              })),
                              {
                                _id: "others",
                                label: t("other"),
                                value: "others",
                              },
                            ].filter((itm) => itm)}
                            getSelectedValue={(e) => {
                              if (e._id === "others") {
                                setEnabledOtherIndustryPopup(true);
                                setOtherIndustryType("industry_add2");
                              }
                              setIndustry2(e._id);
                            }}
                            requiredDisplay={false}
                          />
                        </div>
                      </div>
                      <div className="relative w-2/2 max-w-[calc(50%-1rem)">
                        <Textarea
                          label={t("message")}
                          labelClasses={""}
                          inputClasses={
                            "focus:!border-dark-teal-300 focus:!bg-dark-teal-50/40"
                          }
                          inputPlaceholder={t("write_your_comments")}
                          inputValue={message}
                          inputName={""}
                          errorType={""}
                          setTextarea={setMessage}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="py-3 px-3 border-t border-slate-200">
                    <div className="flex items-center justify-end gap-4">
                      <Button
                        buttonClasses=""
                        buttonLabelClasses=""
                        buttonType={"button"}
                        buttonIcon={
                          isSave
                            ? "fa-light fa-spinner fa-spin"
                            : "fa-light fa-save"
                        }
                        buttonIconPosition={"left"}
                        buttonLabel={t("submit")}
                        functions={onSubmit}
                        buttonHasLink={false}
                        buttonDisabled={isSave}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {enabledOtherStudyPopup && (
        <OtherStudyPopup
          isOpen={enabledOtherStudyPopup}
          setIsOpen={(val) => setEnabledOtherStudyPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {enabledOtherIndustryPopup && (
        <OtherIndustryPopup
          isOpen={enabledOtherIndustryPopup}
          setIsOpen={(val) => setEnabledOtherIndustryPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          otherIndustryType={otherIndustryType}
        />
      )}
    </div>
  );
};

export default AddEditPerspectiveBoardmember;
